import { HttpErrorResponse } from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import { throwError } from 'rxjs';
import { GlobalVariables } from '../global';

declare var swal: any;

export const handleApiErrors = (httpErrorResponse: HttpErrorResponse) => {
  if (httpErrorResponse?.error?.errors) {
    return throwError(() => httpErrorResponse.error.errors);
  }

  Sentry.captureException(httpErrorResponse);

  return throwError(() => [
    {
      status: 500,
      message: 'Unexpected error happened, please contact Qtime Support for further assistance',
      title: 'Unknown Error',
    },
  ]);
};

export function getErrorMessage(error) {
  if (error?.[0]?.status == '404') {
    return GlobalVariables.ERROR_MESSAGE_404;
  } else if (error?.[0]?.message) {
    return error[0].message;
  }

  return GlobalVariables.DEFAULT_ERROR_MESSAGE;
}

/**
 * Shared "failed to load screen" dialog used by the screens. Shows a blocking
 * swal; on confirm it either runs `onUnauthorized` (for a 401) or reloads the page.
 */
export function showScreenLoadError(error: any, onUnauthorized: () => void) {
  swal({
    text: getErrorMessage(error),
    type: 'warning',
    allowOutsideClick: false,
    showCancelButton: false,
    allowEscapeKey: false,
    confirmButtonColor: '#3085d6',
    confirmButtonText: 'Refresh the page!',
  }).then(() => {
    if (error?.[0]?.status == '401') {
      onUnauthorized();
    } else {
      location.reload();
    }
  });
}
